import type { Template } from "@/types";

export const LA_05_H3_V2: Template[] = [
    {
        id: "la-05-h3v2-01",
        name: "LA 01 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_01.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 68, y: 48, width: 267, height: 386, rotation: 0, imageRotation: 0 },
            { id: "2", x: 342, y: 48, width: 266, height: 386, rotation: 0, imageRotation: 0 },
            { id: "3", x: 810, y: 48, width: 408, height: 252, rotation: 0, imageRotation: 0 },
            { id: "4", x: 810, y: 308, width: 201, height: 127, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 308, width: 200, height: 127, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-02",
        name: "LA 02 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_02.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 92, y: 48, width: 207, height: 125, rotation: 0, imageRotation: 0 },
            { id: "2", x: 92, y: 180, width: 207, height: 124, rotation: 0, imageRotation: 0 },
            { id: "3", x: 92, y: 312, width: 207, height: 124, rotation: 0, imageRotation: 0 },
            { id: "4", x: 307, y: 48, width: 277, height: 386, rotation: 0, imageRotation: 0 },
            { id: "5", x: 881, y: 48, width: 267, height: 386, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-03",
        name: "LA 03 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_03.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 62, width: 240, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 248, y: 62, width: 240, height: 359, rotation: 0, imageRotation: 0 },
            { id: "3", x: 496, y: 62, width: 283, height: 176, rotation: 0, imageRotation: 0 },
            { id: "4", x: 496, y: 245, width: 283, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 786, y: 62, width: 566, height: 359, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-04",
        name: "LA 04 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_04.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 62, width: 566, height: 359, rotation: 0, imageRotation: 0 },
            { id: "2", x: 573, y: 62, width: 240, height: 359, rotation: 0, imageRotation: 0 },
            { id: "3", x: 821, y: 62, width: 240, height: 359, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1069, y: 62, width: 283, height: 176, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1069, y: 245, width: 283, height: 176, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-05",
        name: "LA 05 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_05.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 134, y: 43, width: 296, height: 196, rotation: 0, imageRotation: 0 },
            { id: "2", x: 134, y: 246, width: 148, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 289, y: 246, width: 296, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 437, y: 43, width: 148, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 593, y: 43, width: 625, height: 398, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-06",
        name: "LA 06 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_06.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 134, y: 43, width: 625, height: 398, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 246, width: 148, height: 195, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 43, width: 148, height: 196, rotation: 0, imageRotation: 0 },
            { id: "4", x: 922, y: 43, width: 296, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 922, y: 246, width: 296, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-07",
        name: "LA 07 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_07.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 134, y: 43, width: 625, height: 398, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 43, width: 296, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 246, width: 296, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1070, y: 43, width: 148, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 246, width: 148, height: 195, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-08",
        name: "LA 08 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_08.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 120, width: 339, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 347, y: 120, width: 151, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 505, y: 120, width: 339, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 120, width: 151, height: 242, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1011, y: 120, width: 341, height: 242, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-09",
        name: "LA 09 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_09.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 0, y: 120, width: 151, height: 242, rotation: 0, imageRotation: 0 },
            { id: "2", x: 158, y: 120, width: 339, height: 242, rotation: 0, imageRotation: 0 },
            { id: "3", x: 505, y: 120, width: 339, height: 242, rotation: 0, imageRotation: 0 },
            { id: "4", x: 852, y: 120, width: 341, height: 242, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1201, y: 120, width: 151, height: 242, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-05-h3v2-10",
        name: "LA 10 - H3V2",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.80/la-05-h3_v2_10.png",
        size: [1352, 483],
        style: {},
        slots: [
            { id: "1", x: 134, y: 43, width: 625, height: 398, rotation: 0, imageRotation: 0 },
            { id: "2", x: 767, y: 43, width: 148, height: 196, rotation: 0, imageRotation: 0 },
            { id: "3", x: 767, y: 246, width: 296, height: 195, rotation: 0, imageRotation: 0 },
            { id: "4", x: 922, y: 43, width: 296, height: 196, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1070, y: 246, width: 148, height: 195, rotation: 0, imageRotation: 0 }
        ],
    }
];